import React, {useEffect, useRef, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {Button} from 'primereact/button';
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import {MultiSelect} from 'primereact/multiselect';
import {Toast} from 'primereact/toast';
import {useAppDispatch, useAppSelector} from 'redux/hooks'
import {setEditType} from "redux/actions/actions";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Paginator} from "primereact/paginator";
import {classNames} from "primereact/utils";
import {Dialog} from "primereact/dialog";
import {ProgressBar} from "primereact/progressbar";
import QueuesListDialog from "../TrunkDialog";
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";
import TrunkListNav from "../TrunkListNav";
import {
    setArchiveTrunkTableToggle,
    setSelectedTrunkIndex,
    setTrunkClearFilters,
    setTrunkCurrentPage,
    setTrunkCurrentPageSize,
    setTrunkDialogVisible,
    setTrunkErrorField,
    setTrunkIds,
    setTrunksUiFilters
} from "../../../../redux/actions/actionsTrunk";
import {
    areSearchParamsEqual,
    buildTrunksSearchParams,
    readInitialTrunksUrlState
} from "../../../../utils/trunksUrlState";
import {archiveOrUnArchiveTrunkById, getAllTrunksWithPagination, getTrunkById} from "../../../../redux/api/apiTrunks";
import {getItem} from "../../../../redux/cache/cacheService";
import {codes} from "../../../../redux/notificationCodes";
import TrunkListDetails from "./TrunkListDetails";
import {getUsersManagerUserBranchesData} from "../../../../redux/api/apiUsersList";
import {getNotificationMessage} from "../../../../redux/api/apiNotifications";
import {TrunkStatusPill} from "../../../../utils/trunkActivity";

const TrunkList = () => {
    const dispatch = useAppDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [initialTrunksUrlState] = useState(readInitialTrunksUrlState);
    const clearFilters = useAppSelector(state => state.TrunksListReducer.clearFilters);
    const trunksList = useAppSelector(state => state.TrunksListReducer.trunksList);
    // @ts-ignore
    const pagination = useAppSelector(state => state.TrunksListReducer.pagination);
    // @ts-ignore
    const paginationPage = useAppSelector(state => state.TrunksListReducer.paginationPage);
    // @ts-ignore
    const paginationSize = useAppSelector(state => state.TrunksListReducer.paginationSize);
    const archiveTableToggle = useAppSelector(state => state.TrunksListReducer.archiveTrunkTableToggle);
    // @ts-ignore
    const loader = useAppSelector(state => state.TrunksListReducer.loading);
    const [visible, setVisible] = useState<boolean>(false);
    const [showUnArchiveNotification, setShowUnArchiveNotification] = useState<boolean>(false);
    const [showCopyNotification, setShowCopyNotification] = useState<boolean>(false);
    const [mobileVisible, setMobileVisible] = useState<boolean>(false);
    const [id, setId] = useState<number>(0);
    const toast = useRef<Toast>(null);
    const [first, setFirst] = useState(() => (initialTrunksUrlState.page - 1) * initialTrunksUrlState.size);
    const [data] = useState<any>(null);
    const [orderBy, setOrderBy] = useState<any>(initialTrunksUrlState.orderBy);
    const [isDescFilter, setIsDescFilter] = useState<boolean>(initialTrunksUrlState.isDesc);
    const [filterCampaignId, setFilterCampaignId] = useState<any>(initialTrunksUrlState.filterCampaignId);
    const [filterCampaignName, setFilterCampaignName] = useState<any>(initialTrunksUrlState.filterCampaignName);
    const [filterPhoneCount, setFilterPhoneCount] = useState<any>(initialTrunksUrlState.filterPhoneCount);
    const [filterCampaignTypeId, setFilterCampaignTypeId] = useState<any>(null);
    const [filterStatusId, setFilterStatusId] = useState<any>(null);
    const [filterBranchId, setFilterBranchId] = useState<any>(null);
    const [filterQueueActive, setFilterQueueActive] = useState<any>(initialTrunksUrlState.filterQueueActive);
    const [sortOrder, setSortOrder] = useState<number>(initialTrunksUrlState.sortOrder);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const dialerPermissions = checkPermissions(rolesVision, 'Trunks');
    const [page, setPage] = useState<any>(initialTrunksUrlState.page);
    const hasInitializedPagination = useRef(false);
    const skipUrlWriteRef = useRef(true);
    const skipArchivePageResetRef = useRef(true);
    const waitingArchiveHydrationRef = useRef(!initialTrunksUrlState.archiveTableToggle);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [selectedRowData, setSelectedRowData] = useState<any | null>(null);
    const archiveQueueMessage = useAppSelector(state => state.NotificationsReducer.archiveQueueMessage);
    const unzipQueueMessage = useAppSelector(state => state.NotificationsReducer.unzipQueueMessage);
    const copyQueueMessage = useAppSelector(state => state.NotificationsReducer.copyQueueMessage);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const trunkData = useAppSelector(state => state.TrunksListReducer.trunkData);

    // @ts-ignore
    const branches = useAppSelector(state => state.UsersListReducer.branches);
    const [sortData, setSortData] = useState<any>({
        isArchived: !archiveTableToggle,
        pageNumber: page ? page : paginationPage,
        pageSize: paginationSize,
        sort: {
            orderBy: orderBy ? orderBy : "Id",
            isDesc: isDescFilter
        }
    });
    // @ts-ignore
    const activeClick = useAppSelector(state => state.UsersListReducer.activeClick);
    const {
        update: hasTrunksUpdatePermission,
        delete: hasTrunksDeletePermission,
    } = dialerPermissions;

    const isActive = [
        {name: 'ACTIVE', value: true},
        {name: 'INACTIVE', value: false},
    ];

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (initialTrunksUrlState.hasAny) {
            if (Object.keys(initialTrunksUrlState.uiFilters || {}).length > 0) {
                dispatch(setTrunksUiFilters(initialTrunksUrlState.uiFilters));
            } else {
                dispatch(setTrunkClearFilters());
            }
            if (initialTrunksUrlState.page !== 1) {
                dispatch(setTrunkCurrentPage(initialTrunksUrlState.page));
            }
            if (initialTrunksUrlState.size !== 10) {
                dispatch(setTrunkCurrentPageSize(initialTrunksUrlState.size));
            }
            if (!initialTrunksUrlState.archiveTableToggle) {
                dispatch(setArchiveTrunkTableToggle(false));
            }
            dispatch(getUsersManagerUserBranchesData(jwtToken?.jwtToken));
            return;
        }

        dispatch(setTrunkClearFilters());
        dispatch(setTrunkCurrentPage(1));
        dispatch(setTrunkCurrentPageSize(10));
        dispatch(setArchiveTrunkTableToggle(true));
        dispatch(getUsersManagerUserBranchesData(jwtToken?.jwtToken));
    }, []);

    const resetTableHorizontalScroll = () => {
        const scrollableBody = document.querySelector('.p-datatable-wrapper');
        if (scrollableBody) {
            scrollableBody.scrollTop = 0; // Сброс прокрутки
            scrollableBody.scrollLeft = 0;
        }
    };

    useEffect(() => {
        if (!hasInitializedPagination.current) {
            hasInitializedPagination.current = true;
            const urlPage = initialTrunksUrlState.page || 1;
            const urlSize = initialTrunksUrlState.size || 10;
            const pageChanged = paginationPage !== urlPage;
            const sizeChanged = paginationSize !== urlSize;
            if (pageChanged) {
                dispatch(setTrunkCurrentPage(urlPage));
            }
            if (sizeChanged) {
                dispatch(setTrunkCurrentPageSize(urlSize));
            }
            if (pageChanged || sizeChanged) {
                return;
            }
        }
        if (!jwtToken?.jwtToken) {
            return;
        }
        if (waitingArchiveHydrationRef.current) {
            if (archiveTableToggle !== initialTrunksUrlState.archiveTableToggle) {
                return;
            }
            waitingArchiveHydrationRef.current = false;
        }
        let filter: { key: string; value: string }[] = [];
        const dataSort: any = {
            isArchived: !archiveTableToggle,
            pageNumber: page ? page : paginationPage,
            pageSize: paginationSize,
            sort: {
                orderBy: orderBy ? orderBy : "Id",
                isDesc: isDescFilter
            }
        }
        if (filterCampaignId?.value) {
            filter.push(filterCampaignId);
        }
        if (filterCampaignTypeId) {
            filterCampaignTypeId.map((item: any) => {
                filter.push(item);
            })
        }
        if (filterStatusId) {
            filterStatusId.map((item: any) => {
                filter.push(item);
            })
        }
        if (filterBranchId) {
            filterBranchId.map((item: any) => {
                filter.push(item);
            })
        }
        if (filterCampaignName?.value) {
            filter.push(filterCampaignName);
        }
        if (filterPhoneCount?.value) {
            filter.push(filterPhoneCount);
        }

        if (filter) {
            dataSort['filter'] = filter;
        }
        if (filterQueueActive && filterQueueActive.length) {
            if (filterQueueActive.length !== 2) {
                filterQueueActive.forEach((item: any) => {
                    dataSort['isActive'] = item.value;
                    if (item.value === "true") {
                        dataSort['isActive'] = true;
                    } else if (item.value === "false") {
                        dataSort['isActive'] = false;
                    }
                });
            }
        } else {
            if ("isActive" in dataSort) {
                delete dataSort.isActive;
            }
        }
        resetTableHorizontalScroll();
        dispatch(getAllTrunksWithPagination(dataSort, jwtToken?.jwtToken));
        setSortData(dataSort);
        setPage(null);
    }, [paginationPage, paginationSize, data, archiveTableToggle, orderBy, filterPhoneCount, filterQueueActive, isDescFilter, filterCampaignId, filterCampaignName, filterCampaignTypeId, filterBranchId, jwtToken?.jwtToken]);

    useEffect(() => {
        if (skipUrlWriteRef.current) {
            skipUrlWriteRef.current = false;
            return;
        }

        const nextParams = buildTrunksSearchParams({
            page: paginationPage,
            size: paginationSize,
            orderBy,
            isDesc: isDescFilter,
            sortOrder,
            archiveTableToggle,
            filterCampaignId,
            filterCampaignName,
            filterPhoneCount,
            filterQueueActive,
        });

        if (!areSearchParamsEqual(searchParams, nextParams)) {
            setSearchParams(nextParams, {replace: true});
        }
    }, [
        paginationPage, paginationSize, orderBy, isDescFilter, sortOrder, archiveTableToggle,
        filterCampaignId, filterCampaignName, filterPhoneCount, filterQueueActive, searchParams, setSearchParams
    ]);

    useEffect(() => {
        if (activeClick?.item === "/trunks" && activeClick?.from === '#/trunks') {
            dispatch(getAllTrunksWithPagination(sortData, jwtToken?.jwtToken));
            resetTableHorizontalScroll();
        }
    }, [activeClick]);

    let archiveQueueNotification = getItem(codes.archive_queue_question);
    let unzipQueueNotification = getItem(codes.un_archive_queue_question);
    let copyQueueNotification = getItem(codes.copy_queue_question);

    const progressBar = <ProgressBar mode="indeterminate" style={{height: '2px', maxWidth: '95%'}}></ProgressBar>;
    const deleteQueueQuestion =
        <div>{archiveQueueMessage && archiveQueueMessage?.text ? archiveQueueMessage?.text : archiveQueueNotification ? archiveQueueNotification : progressBar}</div>
    const unArchiveQueueQuestion =
        <div>{unzipQueueMessage && unzipQueueMessage?.text ? unzipQueueMessage?.text : unzipQueueNotification ? unzipQueueNotification : progressBar}</div>
    const copyQueueQuestion =
        <div>{copyQueueMessage && copyQueueMessage?.text ? copyQueueMessage?.text : copyQueueNotification ? copyQueueNotification : progressBar}</div>

    useEffect(() => {
        setSelectedRowData(null);
    }, [archiveTableToggle, paginationPage, paginationSize]);

    useEffect(() => {
        if (skipArchivePageResetRef.current) {
            skipArchivePageResetRef.current = false;
            return;
        }
        if (waitingArchiveHydrationRef.current) {
            return;
        }
        setFirst(0);
        dispatch(setTrunkCurrentPageSize(10));
        dispatch(setTrunkCurrentPage(1));
    }, [archiveTableToggle]);

    const typeBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData?.isGeneralTrunk ? 'Транк Черги' : 'Транк Оператора'}
                </span>
            </React.Fragment>
        );
    };

    const branchBodyTemplate = (rowData: any) => {
        let element = branches?.find((element: { id: number; }) => element?.id === rowData?.branchId);

        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {element?.id} {element?.name}
                </span>
            </React.Fragment>
        );
    };

    const confirmArchiveOrUnarchiveTrunk = () => {
        if (!hasTrunksDeletePermission) {
            return;
        }
        setSelectedRowData(null);
        dispatch(archiveOrUnArchiveTrunkById(id, jwtToken?.jwtToken, sortData));
    }

    const copyQueue = () => {
        if (jwtToken?.jwtToken) {
            // dispatch(copyQueueById(id, jwtToken?.jwtToken, sortData));
        }
    }

    const actionTemplate = (rowData: any) => {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const archiveToastShow = (trunkId: number) => {
            if (!archiveQueueNotification) {
                // dispatch(getNotificationMessage(user.userId, 171, jwtToken?.jwtToken));
            }
            setVisible(true);
            setId(trunkId);
        }

        const unArchiveToastShow = (trunkId: number) => {
            if (!unzipQueueNotification) {
                dispatch(getNotificationMessage(user.userId, 173, jwtToken?.jwtToken));
            }
            setShowUnArchiveNotification(true);
            setId(trunkId);
        }

        return (
            <div className="flex">
                {archiveTableToggle && hasTrunksDeletePermission && (
                    <Button
                        className="p-button-text"
                        icon="pi pi-trash"
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            dispatch(getTrunkById(rowData?.id, jwtToken?.jwtToken));
                            if (selectedRowData != null && selectedRowData === rowData?.id) {
                                archiveToastShow(rowData.id);
                            } else {
                                setSelectedRowData(null);
                                archiveToastShow(rowData.id);
                            }
                        }}
                    />
                )}
                {!archiveTableToggle && hasTrunksDeletePermission && (
                    <Button
                        className="p-button-text"
                        icon="pi pi-folder-open"
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            dispatch(getTrunkById(rowData?.id, jwtToken?.jwtToken));
                            if (selectedRowData != null && trunkData?.id && selectedRowData === rowData?.id) {
                                unArchiveToastShow(rowData.id);
                            } else {
                                setSelectedRowData(null);
                                unArchiveToastShow(rowData.id);
                            }
                        }}
                    />
                )}
            </div>
        );
    };

    const nameBodyTemplate = (rowData: any) => {
        let campaignName = '';
        trunksList.map((item: any) => {
            if (item.id === rowData.id) {
                let name = item.name;
                const truncateWithEllipses = (text: string, max: number) => {
                    return text.substr(0, max - 1) + (text.length > max ? '...' : '');
                }

                if (name) {
                    campaignName = truncateWithEllipses(name, 41)
                }
            }
        });
        return <span>{campaignName}</span>;
    };

    const isActiveFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={isActive}
                    optionLabel="name"
                    optionValue="value"
                    onChange={(e: any) => options.filterCallback(e.value)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                />
            </>
        );
    };

    const formattedBranches = branches?.map((branch: { id: any; name: any; }) => ({
        ...branch,
        label: `${branch.id} ${branch.name}`,
    }));

    const filterClearTemplate = (options: any) => {
        return <Button type="button" icon="pi pi-times" onClick={options.filterClearCallback}
                       className="p-button-secondary"></Button>;
    }

    const filterApplyTemplate = (options: any) => {
        return <Button type="button" icon="pi pi-check" onClick={options.filterApplyCallback} className=""></Button>
    }

    const dataTableRef = useRef<DataTable | any>(null);

    const handleReset = () => {
        dataTableRef?.current?.reset();
        customFilter();
        setSortOrder(0);
        setPage(null);
        dispatch(setTrunkClearFilters());
        dispatch(setTrunkCurrentPageSize(10));
        dispatch(setTrunkCurrentPage(1));
        setFirst(0);
        skipUrlWriteRef.current = true;
        setSearchParams(new URLSearchParams(), {replace: true});
    };

    const onPageChange = (event: any) => {
        setFirst(event.first);
        dispatch(setTrunkCurrentPage(event.page + 1));
        dispatch(setTrunkCurrentPageSize(event.rows));
        setSortData((prev: any) => ({...prev, pageNumber: event.page + 1, pageSize: event.rows}));
    };

    const customSort = (event: any) => {
        const handleAction = (sortField: string) => {
            let newOrderBy: string;

            switch (sortField) {
                case 'Id':
                    newOrderBy = 'Id';
                    break;
                case 'PhonesCount':
                    newOrderBy = 'PhonesCount';
                    break;
                case 'name':
                case 'Name':
                    newOrderBy = 'Name';
                    break;
                case 'priority':
                    newOrderBy = 'Priority';
                    break;
                case 'isActive':
                case 'IsActive':
                    newOrderBy = 'IsActive';
                    break;
                case 'activeOperators':
                    newOrderBy = 'ActiveOperators';
                    break;
                case 'branchId':
                    newOrderBy = 'BranchId';
                    break;
                default:
                    return;
            }

            setOrderBy(newOrderBy);
            setIsDescFilter(!isDescFilter);
            setSortOrder(sortOrder === 1 ? -1 : 1);
        };
        let sortField = event.sortField;
        handleAction(sortField);
    };


    const customFilter = (event?: any) => {
        if (event) {
            const {id, name, phonesCount, isActive} = event.filters;

            setFilterCampaignId(id ? {key: 'Id', value: id.constraints[0].value} : null);
            setFilterCampaignName(name ? {key: 'Name', value: name.constraints[0].value} : null);
            setFilterPhoneCount(phonesCount ? {key: 'PhonesCount', value: phonesCount.constraints[0].value} : null);
            if (isActive?.value) {
                setFilterQueueActive(isActive.value.map((item: any) => ({key: 'IsActive', value: item})));
            } else {
                setFilterQueueActive(null);
            }
        } else {
            setFilterCampaignTypeId(null);
            setFilterCampaignId(null);
            setFilterCampaignName(null);
            setFilterStatusId(null);
            setFilterPhoneCount(null);
            setFilterBranchId(null);
            setOrderBy(null);
            setFilterQueueActive(null);
            setIsDescFilter(true);
        }
    };

    const renderHeader = (field: string, sortField: string) => {
        const sorted = sortField === orderBy;
        const sortIcon = classNames('p-sortable-column-icon', {
            'pi pi-sort-amount-up-alt': sorted && sortOrder === 1,
            'pi pi-fw pi-sort-amount-down': sorted && sortOrder === -1,
            'pi pi-fw pi-sort-alt': sortOrder === 0 || !sorted
        });

        return (
            <div className="flex align-items-center sticky top-0" onClick={() => customSort({'sortField': sortField})}>
                {field} <i className={sortIcon}></i>
            </div>
        );
    };

    const isMobile = () => {
        return windowWidth <= 1248;
    }

    const openEditCampaignDialog = () => {
        dispatch(setTrunkDialogVisible(true));
        dispatch(getTrunkById(selectedRowData, jwtToken?.jwtToken));
        dispatch(setTrunkErrorField(null));
        dispatch(setTrunkIds(null));
        setSelectedRowData(null);
        if (hasTrunksUpdatePermission) {
            dispatch(setEditType(true));
        } else {
            dispatch(setEditType(false));
        }
    }

    const dialogHeader = () => {
        return <>
            <div className="flex align-items-center justify-content-end m-0 p-0 mr-1">
                <Button
                    className="p-dialog-header-icon p-dialog-header-close p-link border-noround	outline-none shadow-none h-full justify-content-end"
                    onClick={() => {
                        openEditCampaignDialog();
                    }}>
                    <span className={classNames('', {
                        'pi pi-pencil': archiveTableToggle && hasTrunksUpdatePermission,
                        'pi pi-eye': !archiveTableToggle || !hasTrunksUpdatePermission
                    })}></span></Button>
            </div>
        </>
    }

    return (
        <div className="layout-dashboard">
            <Toast ref={toast}/>
            <div className="">
                <div className="flex col-12 md:col-12 p-0 flex-wrap">
                    {/*<div className="card widget-table">*/}
                    <div
                        className={classNames('card widget-table col-12 transition-duration-300 monitoring-table align-self-start m-0 mr-0', {'mb-4': selectedRowData && !isMobile(), 'md:col-12': !selectedRowData})}>
                        <TrunkListNav handleReset={handleReset} setSelectedRowData={setSelectedRowData}/>
                        <DataTable
                            ref={dataTableRef}
                            scrollable
                            scrollHeight={(selectedRowData) && !isMobile() ? '35vh' : '70vh'}
                            className="p-datatable-customers monitoring-table"
                            value={trunksList}
                            dataKey="id"
                            lazy
                            filters={clearFilters}
                            rowsPerPageOptions={[10, 15, 25, 50]}
                            rowHover={false}
                            selectionMode="single"
                            selection={selectedRowData}
                            onSort={customSort}
                            onFilter={customFilter}
                            emptyMessage="Нічого не знайдено"
                            responsiveLayout='scroll'
                            onRowClick={(e) => {
                                setSelectedRowData(e.data.id);
                                dispatch(getTrunkById(e.data.id, jwtToken?.jwtToken));
                                dispatch(setSelectedTrunkIndex(e.data.id));
                                setMobileVisible(true);
                                if (isMobile()) {
                                    setMobileVisible(true);
                                }
                            }}
                            loading={loader}
                            rowClassName={(rowData: any): string =>
                                classNames({
                                    'p-highlight': rowData?.id === selectedRowData,
                                    'trunk-inactive-row': rowData?.isActive === false && rowData?.id !== selectedRowData,
                                }) || ''
                            }
                        >
                            <Column
                                field="id"
                                filterField="id"
                                header={renderHeader('ID', 'Id')}
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filterPlaceholder="Введіть ID"
                                filter
                                sortable
                                className={classNames('py-3', {'active-header-column': orderBy === 'Id'})}
                                body={(data) => data.id}
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                style={{cursor: 'pointer', width: '10%', minWidth: '90px'}}
                            />
                            <Column
                                field="name"
                                filterField="name"
                                header={renderHeader('Назва', 'Name')}
                                className={classNames('', {'active-header-column': orderBy === 'Name'})}
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filterPlaceholder="Введіть назву черги"
                                filter
                                sortable
                                body={nameBodyTemplate}
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                style={{cursor: 'pointer', width: '100%', minWidth: '150px'}}
                            />
                            <Column
                                field="phonesCount"
                                filterField="phonesCount"
                                header={renderHeader('Кількість номерів', 'PhonesCount')}
                                className={classNames('', {'active-header-column': orderBy === 'PhonesCount'})}
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filter
                                filterPlaceholder="Введіть кількість"
                                body={data => data?.phonesCount || 0}
                                sortable
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                style={{cursor: 'pointer', width: '100%', minWidth: '150px'}}
                            />
                            <Column
                                field="limitAttemptsCall"
                                filterField="limitAttemptsCall"
                                header={'Ліміт спроб дозвону'}
                                className={classNames('', {'active-header-column': orderBy === 'PhonesCount'})}
                                body={data => data?.limitAttemptsCall || '- - -'}
                                style={{cursor: 'pointer', width: '100%', minWidth: '150px'}}
                            />
                            <Column
                                field="isActive"
                                filterField="isActive"
                                header={renderHeader('Стан', 'IsActive')}
                                className={classNames('', {'active-header-column': orderBy === 'IsActive'})}
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filter
                                body={(data) => <TrunkStatusPill active={!!data?.isActive}/>}
                                sortable
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                filterElement={isActiveFilterTemplate}
                                style={{cursor: 'pointer', width: '100%', minWidth: '150px'}}
                            />
                            {/*<Column*/}
                            {/*    field="activeOperators"*/}
                            {/*    header={renderHeader('Оператори', 'ActiveOperators')}*/}
                            {/*    className={classNames('', {'active-header-column': orderBy === 'ActiveOperators'})}*/}
                            {/*    sortable body={operatorsBodyTemplate}*/}
                            {/*    style={{cursor: 'pointer', width: '10%', minWidth: '115px'}}*/}
                            {/*/>*/}
                            {hasTrunksDeletePermission && archiveTableToggle && (
                                <Column
                                    header="Дія"
                                    body={actionTemplate}
                                    style={{width: '10%', minWidth: '100px'}}
                                />
                            )}
                        </DataTable>
                        <Paginator
                            first={first}
                            rows={paginationSize}
                            totalRecords={pagination.totalItems}
                            rowsPerPageOptions={[5, 10, 15, 25, 50]}
                            onPageChange={onPageChange}
                            className="border-top-1 border-bottom-1"
                        />
                    </div>
                    {selectedRowData && (
                        <>
                            {windowWidth > 1248 && <div
                                className={classNames('card widget-table col-12 md:col-12 align-self-start sticky top-0')}>
                                <TrunkListDetails setSelectedRowData={setSelectedRowData}
                                                  selectedRowData={selectedRowData} windowWidth={windowWidth}/>
                            </div>}

                            {windowWidth <= 1248 && <div>
                                <Dialog visible={mobileVisible} header={dialogHeader} className="monitoring-info"
                                        onHide={() => setMobileVisible(false)}>
                                    <TrunkListDetails/>
                                </Dialog>
                            </div>}
                        </>
                    )}
                    <QueuesListDialog setSelectedRowData={setSelectedRowData}/>
                    <ConfirmDialog visible={showUnArchiveNotification}
                                   onHide={() => setShowUnArchiveNotification(false)}
                                   message={'Транк буде розархівовано. Розархівувати транк?'}
                                   icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити"
                                   accept={() => {
                                       if (!hasTrunksDeletePermission) {
                                           return;
                                       }
                                       confirmArchiveOrUnarchiveTrunk();
                                   }}/>
                    <ConfirmDialog visible={showCopyNotification} onHide={() => setShowCopyNotification(false)}
                                   message={copyQueueQuestion}
                                   icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити"
                                   accept={() => copyQueue()}/>
                    <ConfirmDialog visible={visible} onHide={() => setVisible(false)}
                                   message={'Транк буде архівован та деактивован. Архівувати транк?'}
                                   icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити"
                                   accept={() => {
                                       if (!hasTrunksDeletePermission) {
                                           return;
                                       }
                                       confirmArchiveOrUnarchiveTrunk();
                                   }}/>
                </div>
            </div>
        </div>
    );
};

export default TrunkList;
